import { render, staticRenderFns } from "./testViewDialog.vue?vue&type=template&id=7e8a43f8&scoped=true"
import script from "./testViewDialog.vue?vue&type=script&lang=js"
export * from "./testViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_n3acbem2au4l2e3t4qvos3rwwq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8a43f8",
  null
  
)

export default component.exports